import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { aboutFacts, images, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const AboutSection = () => (
  <section id="about" className="py-24 bg-[#0a0a0a]" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="relative overflow-hidden rounded-lg">
            <img src={images.about} alt="Oficina O.C. Gomes" className="w-full h-[500px] object-cover" data-testid="about-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#FF6B00] text-white p-8 rounded-lg shadow-2xl">
            <div className="text-5xl font-bold">15+</div>
            <div className="text-sm uppercase tracking-wider mt-2">Anos de Experiência</div>
          </div>
        </div>

        <div>
          <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Sobre Nós</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
            Oficina especializada em <span className="text-[#FF6B00]">injeção diesel</span> em São Gonçalo
          </h2>
          <p className="text-gray-400 text-lg mb-8 leading-relaxed">
            A O.C. Gomes fica em Colubandê, São Gonçalo – RJ, e trabalha exclusivamente com sistemas de injeção diesel:
            eletrônica, mecânica e unidades injetoras. Toda peça é testada nas nossas próprias bancadas antes e depois do reparo.
          </p>
          <div className="space-y-4 mb-8">
            {aboutFacts.map((fact) => (
              <div key={fact} className="flex items-start gap-3">
                <CheckCircle2 className="text-[#FF6B00] flex-shrink-0 mt-1" size={24} />
                <span className="text-gray-300 text-base">{fact}</span>
              </div>
            ))}
          </div>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-whatsapp-button"
            className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-md hover:bg-[#1fb857] transition-all duration-300 font-semibold transform hover:scale-105"
          >
            <WhatsAppIcon className="w-5 h-5" />
            Falar com a oficina
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
